import Vue from 'vue';
import Component from 'vue-class-component';
import KEYS from '@/values/keys';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { required } from 'vuelidate/lib/validators';
import { Status } from '@/models/status.model';
import { Prop } from 'vue-property-decorator';
import { AUTH_POPUPS, AUTH_STORAGE_KEYS } from '@/auth/values/auth.values';
import { APP_STORAGE_KEYS } from '@/core/enums/app.enum';
import { LocalStorageService } from '@/services/local-storage.service';
import { CORE_ROUTES } from '@/core/core.router';
import { SubstituteTeacherService } from '@/tools/services/substitute-teacher.service';
import { TOOLS_ROUTES } from '@/tools/tools.router';
import { i18n } from '@/core/lang/core.i18n';
import { isCapacitor } from '@/components/calls/services/browser/browser-utils';

declare const window: any;

@Component({
  name: 'ed-login-popup'
})
export default class EdLoginPopup extends Vue {
  
  @Prop() readonly changeView: any;

  public errorMsg: string; 
  public status: Status = new Status();
  public form: any = {};

  get isElectron() {
    return  window.electronVersions && 'electron' in window.electronVersions ;
  }

  get isCapacitor() {
    return isCapacitor();
  }

  initForm(user: string = '') {
    this.form = EdFormModel([
      EdInputModel('user', user, { required }),
      EdInputModel('password', '', { required }),
    ]);
  }

  async login() {
    try {
      const $root: any = this.$root;
      if(!this.status.loading) {
        this.status.setLoading();
        LocalStorageService.removeItem(AUTH_STORAGE_KEYS.ED_JWT);
        await this.$Auth.Store.login({
          username: encodeURIComponent(this.form.user.value),
          password: encodeURIComponent(this.form.password.value)
        });
        LocalStorageService.removeItem(APP_STORAGE_KEYS.STUDENT_MODE);
        await $root.startSession();
        this.$router.push({ name: CORE_ROUTES.PORTAL.NAME });
        let pendingInvitations = await SubstituteTeacherService.getPendingInvitations();
        this.modalPendingInvitations(pendingInvitations);
        sessionStorage.removeItem('savedUsername');
      }
    } catch(e) {
      this.errorMsg = e.message;
      this.status.setError();
    }
  }

  goToRegister() {
    this.$router.push({ name: CORE_ROUTES.PUBLIC.REGISTER.NAME });
  }

  goToForgotPassword() {
    this.$emit('changeView', AUTH_POPUPS.FORGOT_PASSWORD);
  }

  setInputsBehavior() {
    // Firefox: Form not triggering changes when autofill
    const fillUser = ({target}) => {
      if(target.value.length > 0) {
        this.form.user.value = target.value;
        this.form.user.valid = true;
        if(this.form.password.valid) this.form.valid = true;
      }
    }
    const fillPassword= ({target}) => {
      if(target.value.length > 0) {
        this.form.password.value = target.value;
        this.form.password.valid = true;
        if(this.form.user.valid) this.form.valid = true;
      }
    }
    document.querySelectorAll('input')[0].addEventListener('animationstart', fillUser, false);
    document.querySelectorAll('input')[1].addEventListener('animationstart', fillPassword, false);
  }

  modalPendingInvitations(invitations) {
    if(invitations.length > 0) {
      this.$EdModal.createConfirmationModal({
        title: `${i18n.t('tools.substituteTeacher.pendingInvitations')}`,
        body: `${i18n.t('tools.substituteTeacher.info.pendingInvitations')}`,
        actionText: `${i18n.t('common.go')}`,
        action: () => {
          this.$router.push({ name: TOOLS_ROUTES.SUBSTITUTE_TEACHER_ADMIN.NAME, query: { status: 'pending'} })
        },
        type: KEYS.EVENT_TYPES.WARNING
      });
    }
  }

  loadStoredUsername() {
    const savedUsername = sessionStorage.getItem('savedUsername');
    this.initForm(savedUsername || '');
  }

  sessionStoreUsername() {
    sessionStorage.setItem('savedUsername', this.form.user.value);
  }

  mounted() {
    this.setInputsBehavior();
    this.loadStoredUsername();
  }

}